/*
 * @Author: 张锐
 * @Date: 2021-04-28 18:47:26
 * @LastEditTime: 2021-04-28 19:03:07
 * @Description: 浏览器相关工具函数
 */

/**
 * @description: 判断是否为360浏览器
 * @param {*} option
 * @param {*} value
 * @return {*}
 */
export function validate360(option, value) {
    const mimeTypes = window.navigator.mimeTypes
    for (let mt in mimeTypes) {
        if (mimeTypes[mt][option] === value) {
            return true
        }
    }
    return false
}

/**
 * @description: 通过用户 UA 判断浏览器类型并返回浏览器类型和版本
 * @return {Object} 返回一个包含浏览器类型和浏览器版本的对象
 */
export function getBrowerInfo() {
    let userAgent = window.navigator.userAgent.toLowerCase()
    let browserType = ''
    let browserVersion = ''
    let isIE = userAgent.match(/msie/) != null || userAgent.match(/trident/) != null
    // 浏览器类型-IE
    if (userAgent.match(/msie/) != null || userAgent.match(/trident/) != null) {
        browserType = 'IE'
        browserVersion = getIeVersion()
    } else if (window.opera || userAgent.indexOf('opr') > 0) {
        // 欧朋
        browserType = '欧朋'
        browserVersion = getOperaVersion(userAgent)
    } else if (userAgent.indexOf('ubrowser') > 0) {
        // UC
        browserType = 'UC'
        browserVersion = userAgent.match(/ubrowser\/([\d.]+)/)[1]
    } else if (userAgent.indexOf('bidubrowser') > 0) {
        // 百度
        browserType = '百度'
        browserVersion = userAgent.match(/bidubrowser\/([\d.]+)/)[1]
    } else if (userAgent.indexOf('metasr') > 0 || userAgent.indexOf('se 2.x') > 0) {
        // 搜狗
        browserType = '搜狗'
        // browserVersion =  userAgent.match(/metasr\/([\d.]+)/)[1]
    } else if (userAgent.indexOf('tencenttraveler') > 0) {
        // QQ
        browserType = 'QQ'
        browserVersion = userAgent.match(/tencenttraveler\/([\d.]+)/)[1]
    } else if (userAgent.indexOf('qqbrowser') > 0) {
        // QQ
        browserType = 'QQ'
        browserVersion = userAgent.match(/qqbrowser\/([\d.]+)/)[1]
    } else if (userAgent.indexOf('maxthon') > 0) {
        // 遨游
        browserType = '遨游'
        browserVersion = userAgent.match(/maxthon\/([\d.]+)/)[1]
    } else if (userAgent.indexOf('firefox') > 0) {
        // 火狐
        browserType = '火狐'
        browserVersion = userAgent.match(/firefox\/([\d.]+)/)[1]
    } else if (userAgent.indexOf('edge') > 0) {
        // edge
        browserType = 'Edge'
        browserVersion = userAgent.match(/edge\/([\d.]+)/)[1]
    } else if (userAgent.indexOf('chrome') > 0) {
        // 谷歌/360
        if (validate360('type', 'application/x360mmplugin')) {
            browserType = '360'
            // browserVersion =  userAgent.match(/chrome\/([\d.]+)/)[1]
        } else {
            browserType = '谷歌'
            browserVersion = userAgent.match(/chrome\/([\d.]+)/)[1]
        }
    } else if (userAgent.indexOf('safari') > -1) {
        // 苹果
        browserType = 'safari'
        browserVersion = userAgent.match(/version\/([\d.]+)/)[1]
    }
    return { browserType, browserVersion }
}

/*
     * 获取IE浏览器版本
     */
export function getIeVersion() {
    const IEMode = document.documentMode;
    const rMsie = /(msie\s|trident.*rv:)([\w.]+)/;
    const ma = window.navigator.userAgent.toLowerCase();
    const match = rMsie.exec(ma);
    try {
        return match[2];
    } catch (e) {
        return IEMode;
    }
};

/*
 * 获取oper浏览器版本
 */
export function getOperaVersion(userAgent) {
    try {
        if (window.opera) {
            return userAgent.match(/opera.([\d.]+)/)[1];
        } else if (userAgent.indexOf("opr") > 0) {
            return userAgent.match(/opr\/([\d.]+)/)[1];
        }
    } catch (e) {
        return 0;
    }
};




// WEBPACK FOOTER //
// ./src/comm/utils/useAgent.js